import React from 'react'

function BuenServicio({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" {...r}>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M24.82 11.18c2.15 5.39 7.43 9.2 13.59 9.2h1.38m-5.76 14.24v4.2a3.91 3.91 0 01-3.91 3.91h-2.79a3.91 3.91 0 01-3.91-3.91v-4.2"
      ></path>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M29.83 34.7h-2.21c-5.77 0-10.44-4.68-10.44-10.44v-8.81C17.17 9.68 21.85 5 27.61 5h2.21c5.77 0 10.44 4.68 10.44 10.44v8.81c.01 5.78-4.66 10.45-10.43 10.45zm-7.38 2.34h-3.21c-2.28 0-4.48 1.04-5.76 2.92a6.468 6.468 0 00-1.14 3.65l.01 13.92"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M46.65 58.52c5.606 0 10.15-4.544 10.15-10.15 0-5.606-4.544-10.15-10.15-10.15-5.606 0-10.15 4.544-10.15 10.15 0 5.606 4.544 10.15 10.15 10.15z"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M41.72 48.72l3.05 3.05 6.81-6.8"
      ></path>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M23.93 26.92c1.26 1.39 3.05 2.27 5.07 2.27 2.02 0 3.81-.88 5.07-2.27"
      ></path>
    </svg>
  )
}

export default BuenServicio